var React = require("react");
const createReactClass = require('create-react-class')
var _ = require('underscore');

/**
 * Defines a set of checkbox inputs that will submit as one input.
 * Note that some of these methods are duplicated in InputMixin, but it doesn't
 * look possible for this component to overload specific mixin methods.
 */
module.exports = createReactClass({

	getInitialState: function() {
		// get the initial structure of the input states for internally
		// knowing what is checked. This gets updated by setValue
		// internally
		var data = _.map(this.props.source, function(value) {
			return {
				value: value,
				title: this.props.source[value],
				selected: _.contains(this.props.value, value)
			};
		}.bind(this));

		return {
			isValid: true,
			data: data,
			value: this.props.value || [],
			serverErrors: null
		};
	},

	componentWillMount: function() {
		this.props.attachToForm(this);
		if (_.has(this.props, 'onSetValue')) this.props.onSetValue(this.props.value);
	},

	componentWillUpdate: function(nextProps, nextState) {
		if (this.state.value !== nextState.value) {
			if (_.has(this.props, 'onSetValue')) this.props.onSetValue(nextState.value);
		}
	},

	componentWillUnmount: function() {
		this.props.detachFromForm(this);
	},

	handleCheckboxChange: function(checkboxValue) {
		var newValue = [];
		var data = this.state.data.map(function(item) {
			var selected = (item.value === checkboxValue ? !item.selected : item.selected);

			// set the value of the field to be the items that are selected
			if (selected === true) {
				newValue.push(item.value);
			}

			return {
				value: item.value,
				title: item.title,
				selected: selected
			};
		});

		this.setState({
			data: data,
			value: newValue
		});
	},

	listCheckbox: function(wrapperCss, item) {
		return (
			<div className={wrapperCss} key={this.name + "_" + item.value}>
				<label htmlFor={this.name + "_" + item.value}>
					<input
						className="checkbox"
						type="checkbox"
						id={this.name + "_" + item.value}
						name={this.name + "[]"}
						value={item.value}
						onChange={this.handleCheckboxChange.bind(this, item.value)}
						checked={item.selected}
					/>
					{item.title}
				</label>
			</div>
		);
	},

	render: function() {
		var alert;
		var inputs;
		if (!this.state.isValid) {
			alert = <div className='validation-message'>{this.state.serverError || this.props.validationError}</div>;
		}

		var wrapperCss = 'checkbox';
		if (this.props.inline) {
			wrapperCss = 'checkbox-inline';
		}
		if (this.props.rowLimit > 0 && wrapperCss === 'checkbox') {
			// set a limit to the number of checkboxes in a row when wrapperCSS is checkbox
			// do a div for each group of labels up to some limit
			inputs = [];
			var len = (this.state.data.length - this.props.rowLimit);
			var len2 = this.props.rowLimit;
			for (var i = 0; i < len; i += len2) {
				var boxes = [];
				for (var j = 0; j < len2; j++) {
					var item = this.state.data[i + j];
					boxes.push(
						this.listCheckbox(wrapperCss, item)
					);
				}
				inputs.push(
					<div className='col-md-6' key={this.name + "_col" + i}>
					{boxes}
					</div>
				);
			}
			// one more group of remaining checkboxes
			var last_boxes = [];
			for (var i2 = len; i2 < this.state.data.length; i2++) {
				var text = this.state.data[i2];
				last_boxes.push(
					this.listCheckbox(wrapperCss, text)
				);
			}
			inputs.push(
				<div className='col-md-6' key={this.name + "_col" + len}>
					{last_boxes}
				</div>
			);
		} else {
			inputs = this.state.data.map(function(datum) {
				return (
					this.listCheckbox(wrapperCss, datum)
				);
			}.bind(this));
		}
		return (
			<div className="form-group">
				{alert}
				{inputs}
			</div>
		);
	}
});
